"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchGetOtpChannel = void 0;
const fetchGetOtpChannel = (api, progressId, url) => api.GET(url, {
    headers: {
        progressId,
    },
});
exports.fetchGetOtpChannel = fetchGetOtpChannel;
//# sourceMappingURL=resolver.js.map